import aurelia from "./aurelia";
import epitome from "./kshetrapal/epitome";
import infinity from "./kshetrapal/infinity";
import evana from "./kshetrapal/evana";
import elianaCity from "./kshetrapal/eliana-city";
import industrialPark from "./kshetrapal/industrial-park";

/*
 * Sthaan project registry.
 * Every project is a self-contained content module — sections are declared
 * per project, so each showcase can be crafted from whatever genuine
 * material the developer supplies. Projects with visibility "private"
 * (like the concept demo) never appear in public discovery, search,
 * city pages or counts.
 */
const PROJECTS = [epitome, infinity, evana, elianaCity, industrialPark, aurelia];

export const publicProjects = PROJECTS.filter((p) => p.visibility !== "private");

export const getProjectBySlug = (slug) =>
    PROJECTS.find((p) => p.slug === slug) || null;

export const projectsByCity = (citySlug) =>
    publicProjects.filter((p) => p.citySlug === citySlug);

export const projectsByCategory = (category) =>
    publicProjects.filter((p) => p.category === category);

export const countByCity = (citySlug) => projectsByCity(citySlug).length;

export const countByCategory = (category) => projectsByCategory(category).length;

export function searchProjects({ q = "", city = "", status = "", category = "" }) {
    const needle = q.trim().toLowerCase();
    return publicProjects.filter((p) => {
        if (category && p.category !== category) return false;
        if (city && p.citySlug !== city) return false;
        if (status && p.status !== status) return false;
        if (!needle) return true;
        const hay = [p.name, p.locality, p.city, p.developer?.name]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
        return hay.includes(needle);
    });
}
